// A tiger, modelled facing +X: an orange body banded with dark stripes, a rounded
// head and a long tail. Ported 1:1 from age-of-mcp's classic tiger.ts, restoring
// its leg loop, body/head/tail core and the stripe loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.06, 0.028], [0.06, -0.028], [-0.06, 0.028], [-0.06, -0.028]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.009, 0.008, 0.082, 4),
      color: "#d77b28", position: [x!, 0.041, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#e2842c",
      position: [0, 0.082, 0], scale: [1.9, 0.95, 0.9] },            // body
    { geometry: new THREE.IcosahedronGeometry(0.032, 0), color: "#e88f38",
      position: [0.1, 0.088, 0] },                                   // head
    { geometry: new THREE.ConeGeometry(0.013, 0.024, 4), color: "#f4f0e8",
      position: [0.126, 0.082, 0], rotation: [0, 0, -Math.PI / 2] },   // muzzle
    { geometry: new THREE.CylinderGeometry(0.005, 0.004, 0.085, 4), color: "#e2842c",
      position: [-0.105, 0.085, 0], rotation: [0, 0, 0.9] },        // tail
  );
  // Dark stripes over body and tail.
  for (let i = 0; i < 5; i++) {
    parts.push({ geometry: new THREE.BoxGeometry(0.01, 0.085, 0.085),
      color: "#2a1c12", position: [-0.05 + i * 0.028, 0.085, 0] });
  }
  return parts;
}

export const tiger = defineModel({
  id: "tiger",
  scale: 3.08, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Tiger",
  tags: ["creature","tiger","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tiger.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.14,
  parts: () => partsFor(),
  animations: [],
});
